export enum PageType {
  Article = "article",
  Author = "author",
  Authors = "authors",
  Homepage = "homepage",
  Live = "live",
  Opinion = "opinion",
  Others = "others",
  Page = "page",
  Podcast = "podcast",
  Posties = "posties",
  PostiesKids = "posties-kids",
  PostiesParents = "posties-parents",
  Section = "section",
  Series = "series",
  StoryStyle = "story-style",
  Topic = "topic",
  Topics = "topics",
}
